const columns = [
    {text: 'Descrição', width: '100%', className: 'text-max-sm link-button', name: 'UPPER(description)', hasOrder: true},
    {text: 'Ações', width: '', className: 'text-center text-max-sm', hasOrder: false}
];

export default columns;
